import Controls from '@stories/Components/Misc/Carousels/Carousel/Controls/Controls';
import Dots from '@stories/Components/Misc/Carousels/Carousel/Dots/Dots';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Pagination.styles';
const Pagination = React.forwardRef((_, ref) => {
    const carousel = useCarouselContext();
    const dotsRef = React.useRef(null);
    const normalDotSize = React.useRef(0);
    const gap = React.useRef(0);
    React.useEffect(() => {
        if (dotsRef.current) {
            const scrollableBit = dotsRef.current.childNodes.item(0);
            if (!normalDotSize.current || !gap.current) {
                // Do the measuring //
                const normalDot = dotsRef.current.querySelector("[data-active='false']");
                if (normalDot) {
                    normalDotSize.current = Number.parseFloat(window.getComputedStyle(normalDot).width.replace('px', ''));
                }
                const gapStyle = window.getComputedStyle(scrollableBit);
                gap.current = Number.parseFloat(gapStyle.gap.replace('px', '')) || 0;
            }
            const activeDot = dotsRef.current.querySelector("[data-active='true']");
            if (activeDot) {
                const offset = normalDotSize.current * carousel.activeIndex + gap.current * carousel.activeIndex;
                scrollableBit.scrollTo({
                    left: offset,
                    behavior: 'smooth',
                });
            }
        }
    }, [carousel.activeIndex, dotsRef.current]);
    if (carousel.maxIndex === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: ref },
        React.createElement(Controls, { oneButton: "left" }),
        React.createElement("div", { style: { display: 'contents' }, ref: dotsRef },
            React.createElement(Dots, { itemCount: carousel.maxIndex + 1, activeIndex: carousel.activeIndex })),
        React.createElement(Controls, { oneButton: "right" })));
});
Pagination.displayName = 'CarouselPagination';
export default Pagination;
